__webpack_require__.p = "/reports-new-empty-dashboard/referrals-hub/";